import { render, staticRenderFns } from "./demographics-category-card.vue?vue&type=template&id=7fe4ec7c&scoped=true&"
import script from "./demographics-category-card.vue?vue&type=script&lang=js&"
export * from "./demographics-category-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe4ec7c",
  null
  
)

export default component.exports